"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphErrorTypes = exports.NodeType = void 0;
var NodeType;
(function (NodeType) {
    NodeType["POPULATE_SOURCE"] = "populate_source";
    NodeType["GROUP_BY"] = "group_by";
    NodeType["SUM_IF"] = "sum_if";
    NodeType["MANUAL"] = "manual";
    NodeType["SOURCE"] = "source";
    NodeType["JOIN"] = "join";
    NodeType["UNION"] = "union";
    NodeType["FORMULA"] = "formula";
    NodeType["PROCV"] = "procv";
    NodeType["FILTER"] = "filter";
    NodeType["PULL"] = "pull";
    NodeType["CREATE_TEMP_TABLE"] = "create_temp_table";
    NodeType["CREATE_TEMP_TABLE_V2"] = "create_temp_table_v2";
    NodeType["COMMIT_TEMP_TABLE"] = "commit_temp_table";
    NodeType["WINDOW_FUNCTION"] = "window_function";
    NodeType["UPLOAD_TAB"] = "upload_tab";
    NodeType["METADATA"] = "metadata";
    NodeType["PLAN_VARIABLE"] = "plan_variable";
    NodeType["WEBHOOK"] = "webhook";
    NodeType["BIG_QUERY"] = "big_query";
    NodeType["PLAN_UNION"] = "plan_union";
    NodeType["USER"] = "user";
    NodeType["UNION_V2"] = "union_v2";
    NodeType["PAYMENT"] = "payment";
    NodeType["CREATE_OR_REPLACE_BQ_TABLE"] = "create_or_replace_bq_table";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
var GraphErrorTypes;
(function (GraphErrorTypes) {
    GraphErrorTypes["NODE_ERROR"] = "node_error";
    GraphErrorTypes["EXTERNAL_NODE_ERROR"] = "external_node_error";
    GraphErrorTypes["PARENT_ERROR"] = "parent_error";
})(GraphErrorTypes = exports.GraphErrorTypes || (exports.GraphErrorTypes = {}));
